module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAALCAQAAAAHUG+QAAAAZklEQVQI12NgAAFuhmaG3QwzGOQYoICJ4QjDPAYXhiqGpwziECFbhrNQyUkMFRBGIsN8qFAywxwQJclwiuEVw0kwvMfwmMGagSGB4T8KnM3AkIQmNJdYIUc0oWqQncoM5nCoz8AIAFnVOEzZvb0RAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/wifi_encrypted.png
// module id = 185
// module chunks = 1